import { Component } from "@angular/core";
import { AvatarForUserProfile } from "@helpers/avatarHelper";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { HelpDocumentService } from "@services/helpDocument.service";
import { UserService } from "@services/user.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "help",
	styleUrls: ["help.css"],
	templateUrl: "help.html"
})
export class HelpAdminComponent {
	categories: any[] = [];
	filteredItems: any[] = [];
	formDetails: any = { keywords: "" }
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Help Document"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	keywords = "";
	selectedCat = "";
	submitButtonOptions = { text: "Search", useSubmitBehavior: true }
	title: string;
	users: any[] = [];

	constructor(private toastService: ToastService, private itemService: HelpDocumentService, private usersService: UserService) {
		this.title = `${this.itemType}s`;
		this.getUsers();
		this.getItems();
	}

	clearSearch() {
		this.selectedCat = "";
		this.keywords = "";
		this.getItems();
	}

	filterCats(catName: string) {
		this.selectedCat = catName;
		this.filteredItems = this.items.filter(x => x.section === catName);
	}

	getItems() {
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.categories = [];
					this.items = res.response.items;
					this.filteredItems = res.response.items;
					const tempCats = [...new Set(res.response.items.map((item: { section: any; }) => item.section))]; // [ 'A', 'B']
					tempCats.forEach(cat => {
						const count = this.items.filter(x => x.section === cat).length;
						this.categories.push({ count: count, name: cat });
					});
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getUsers() {
		this.usersService.getAll()
			.subscribe(
				(res: any) => {
					this.users = res.response.items;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	handleSubmit() {
		if (this.keywords.trim() === "") {
			this.getItems();
		} else {
			this.search();
		}
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	renderAuthor(authorId: number) {
		const userProfile = this.users.find(x => x.id === authorId);
		return AvatarForUserProfile(userProfile);
	}
	renderAuthorName(authorId: number) {
		const userProfile = this.users.find(x => x.id === authorId);
		return userProfile.firstName + " " + userProfile.lastName;
	}

	search() {
		this.itemService.search(this.keywords.trim())
			.subscribe(
				(res: any) => this.items = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}
}